/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialPaymentMethodEditorViewModel } from "../types/CourseFinancialPaymentMethodEditorViewModel.ts";
import { ePaymentMethodSchema } from "./ePaymentMethodSchema.ts";

export const courseFinancialPaymentMethodEditorViewModelSchema = z.object({
  id: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID da forma de pagamento do plano. Zero para incluir; informe o ID existente para manter ou alterar. As omitidas são removidas.",
      ),
  ),
  paymentMethod: z.optional(
    z
      .lazy(() => ePaymentMethodSchema)
      .describe(
        "1 = Billet | 2 = CreditCardAprovaFacil | 3 = CreditCardMundiPagg | 4 = BankDeposit | 5 = CreditCardStripe | 6 = BilletPecegePay | 7 = CreditCardPecegePay | ",
      ),
  ),
  isInstallment: z.optional(
    z
      .boolean()
      .describe(
        "Define se a forma de pagamento é parcelada. Permitido apenas para cartão de crédito MundiPagg e PecegePay.",
      ),
  ),
  numberParcels: z
    .number()
    .int()
    .describe(
      "Número de parcelas. Entre 1 e 100. Obrigatório quando IsInstallment é verdadeiro e descartado quando é falso.",
    )
    .nullish(),
  fixParcelNumber: z.optional(
    z.boolean().describe("Define se o número de parcelas é fixo."),
  ),
}) as unknown as ToZod<CourseFinancialPaymentMethodEditorViewModel>;
